export const colorsRadioAndCheckbox = {
  // Radio theme
};
